import axios from 'axios'

export default {
  methods: {
    async getToken () {
      return axios.get(`${process.env.VUE_APP_API_BASE_URL}/sanctum/csrf-cookie`)
    }
  }
}
